/* React */
import React from "react";

/* Ionic */
import { IonItem, IonIcon, IonLabel } from "@ionic/react";

/* Stylesheet */
import styles from "./CheckboxItem.module.scss";

/* Interfaces */
interface CheckboxItemProps {
  label: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
}

const CheckboxItem: React.FC<CheckboxItemProps> = ({
  label,
  icon,
  onClick,
  disabled = false,
}) => {
  return (
    <IonItem
      className={styles.checkbox_item}
      lines="none"
      button
      disabled={disabled}
      onClick={onClick}
    >
      <IonIcon className={styles.icon} icon={icon} />
      <IonLabel className={styles.label}>{label}</IonLabel>
    </IonItem>
  );
};

export default CheckboxItem;
